import { IIconBase } from '..'

const graphIcon = ({
  color = '#ffffff',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_6128_7858)'>
        <rect width={width} height={height} fill={color} fillOpacity='0.01' />
        <path
          d='M5.99992 14.6663H9.99992C13.3333 14.6663 14.6666 13.333 14.6666 9.99967V5.99967C14.6666 2.66634 13.3333 1.33301 9.99992 1.33301H5.99992C2.66659 1.33301 1.33325 2.66634 1.33325 5.99967V9.99967C1.33325 13.333 2.66659 14.6663 5.99992 14.6663Z'
          stroke='#333752'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.88672 9.65984L6.47339 7.59984C6.70005 7.30651 7.12005 7.25318 7.41339 7.47984L8.63339 8.43984C8.92672 8.66651 9.34672 8.61318 9.57339 8.32651L11.1134 6.33984'
          stroke='#333752'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_6128_7858'>
          <rect width={width} height={height} fill={color} />
        </clipPath>
      </defs>
    </svg>
  )
}

export default graphIcon
